import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a5ae81d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main tw-overflow-x-hidden" }
const _hoisted_2 = { class: "tw-flex org-header tw-gap-[30px] tw-py-[55px] lg:tw-px-[60px] tw-bg-[#ffffff]" }
const _hoisted_3 = { class: "tw-flex tw-flex-col tw-justify-center tw-gap-[8px]" }
const _hoisted_4 = { class: "org-title-name" }
const _hoisted_5 = { class: "org-domain" }
const _hoisted_6 = { class: "contain tw-py-[40px] tw-px-[60px] tw-relative xl:tw-py-[55px]" }
const _hoisted_7 = { class: "tw-flex xl:tw-flex-row tw-flex-col-reverse tw-gap-[40px] xl:tw-gap-[60px]" }
const _hoisted_8 = { class: "tw-left-sidebar-contain tw-max-w-[1182px]" }
const _hoisted_9 = {
  id: "clickbox-detail",
  class: "tw-left-sidebar tw-pb-10 tw-bg-white tw-mb-[30px]"
}
const _hoisted_10 = { class: "org-detail tw-pt-5 tw-pb-5 tw-pl-10 tw-pr-10" }
const _hoisted_11 = { class: "header-title" }
const _hoisted_12 = {
  key: 0,
  class: "tw-line tw-mt-10 tw-mb-10"
}
const _hoisted_13 = { class: "tw-pl-10 tw-pr-10" }
const _hoisted_14 = {
  id: "clickbox-setting",
  class: "tw-left-sidebar tw-pb-10 tw-bg-white tw-max-w-[1182px]"
}
const _hoisted_15 = { class: "org-detail tw-pt-5 tw-pb-5 tw-pl-10 tw-pr-10" }
const _hoisted_16 = { class: "header-title" }
const _hoisted_17 = {
  key: 0,
  class: "tw-line tw-mt-10 tw-mb-10"
}
const _hoisted_18 = { class: "tw-pl-10 tw-pr-10" }
const _hoisted_19 = { class: "tw-right-sidebar" }

import AppBarLayout from "@/components/layouts/appBarLayout.vue";
import store from "@/store";
import {
  Ref,
  computed,
  onBeforeMount,
  reactive,
  ref,
  watch,
  onMounted,
} from "vue";
import backgroundComponent from "@/components/common/backgroundComponent.vue";
import ActivePathWrapper from "@/components/common/activePathWrapper.vue";
import { IOrgDetails, IOrgUpdateInput } from "@/interfaces/orgInterfaces";
import cloneDeep from "lodash/cloneDeep";
import BaseInput from "@/components/common/form/baseInput.vue";
import useVuelidate from "@vuelidate/core";
import { helpers, maxLength, minLength, required } from "@vuelidate/validators";
import { getComponentUiText, compareObjects } from "@/utils/utilities";
import { IEditOrgDetail } from "@/interfaces/orgInterfaces";
import ActionButton, { Action } from "@/components/common/actionButton.vue";
import UserIcon from "@/components/svgs/userIcon.vue";
import AddIcon from "@/components/svgs/addIcon.vue";
import { putOrgProfile } from "@/services/org";
import { showErrorAPI } from "@/services/apiRoutes";
import { Org } from "@/services/apiRoutes/routes";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import router from "@/router";
import { routers } from "@/utils/constants";
import GlobalAvatar from "@/components/common/globalAvatar.vue";
import dayjs from "dayjs";
import DatePicker from "@/components/common/datePicker.vue";
import { INPUT_TYPE } from "@/utils/constants";
import ToggleSwitch from "@/components/common/toggleSwitch.vue";
export type inputFiled = {
  label: string;
  hindText: string;
  type?: string;
  required: boolean;
  valueField: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'orgDetail',
  setup(__props) {

const isEnableButton = computed(() => {
  const formCompare = {
    ...form,
    foundedDate: form.foundedDate
      ? dayjs(form.foundedDate).format("YYYY-MM-DD")
      : "",
  };
  const oldValueOrgCompare = {
    ...oldValueOrg.value,
    foundedDate: oldValueOrg.value.foundedDate
      ? dayjs(oldValueOrg.value.foundedDate).format("YYYY-MM-DD")
      : "",
  };
  return compareObjects(formCompare, oldValueOrgCompare);
});
const oldValueOrg: Ref<any> = ref({});
let orgDataDetailInput: Ref<inputFiled[]> = ref([]);
let orgDataSettingInput: Ref<inputFiled[]> = ref([]);
const urlAvatar = computed(() => store.getters["Org/getCurrentOrg"].img);
const currentOrgStore: Ref<IOrgDetails> = computed(
  () => store.getters["Org/getOrgDetails"],
);
let currentOrg: Ref<IOrgDetails> = cloneDeep(ref(currentOrgStore.value));
const currentOrgName = computed(() => cloneDeep(currentOrgStore.value.name));
const emitOrg = () => {
  currentOrg.value = cloneDeep(currentOrgStore.value);
  initFormValue();
};
onBeforeMount(() => {
  initFormValue();
});
onMounted(() => {
  setTimeout(() => {
    const autoFocus = document.getElementsByClassName(
      "autoFocus",
    )[0] as HTMLInputElement;
    autoFocus.focus();
  }, 100);
});
const validateFoundedDate = (val) => {
  if (val) {
    const date = dayjs(val);
    return date.isValid() && date.diff(dayjs(), "months", true) <= 12;
  }
  return true;
};

const validateNameCode = (val) => {
  const validChars = /[^a-zA-Z0-9\-_+&()!]/;
  if (val) {
    return !validChars.test(val);
  }
  return false;
};
const rules = {
  name: {
    required: helpers.withMessage(
      () =>
        getComponentUiText("app-common-form-field-required-1", false, {
          field: getComponentUiText(
            "app-settings-organisation-detail-display-name-1",
          ),
        }),
      required,
    ),
  },
  id: {},
  icon: {},
  domainPrimary: {},
  nameLegal: {},
  nameCode: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
    minLength: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-organisation-manage-access-create-org-modal-name-code-invalid-2",
        ),
      minLength(2),
    ),
    maxLength: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-organisation-manage-access-create-org-modal-name-code-invalid-2",
        ),
      maxLength(4),
    ),
    alphaNum: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-organisation-manage-access-create-org-modal-name-code-invalid-2",
        ),
      validateNameCode,
    ),
  },
  location: {},
  foundedDate: {
    maxValue: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-organisation-detail-founded-date-invalid-1",
        ),
      validateFoundedDate,
    ),
  },
  locationCode: {},
  language: {},
  timezone: {},
  registerNumber: {},
};

const initialForm = {
  name: "",
  id: "",
  icon: "",
  domainPrimary: "",
  nameLegal: "",
  nameCode: "",
  location: "",
  foundedDate: "",
  locationCode: "",
  language: "",
  timezone: "",
  registerNumber: "",
  requireMFA: false,
  secretDisabledPasswordReset: false,
  secretDisabledEmailVerify: false,
  secretDisabledUserInvite: false,
  secretDisabledChecklistRequested: false,
};
const form = reactive(initialForm);
const isLoading = computed(() => store.state.Org.isLoadingOrg);
const v$ = useVuelidate(rules, form, { $scope: false });

watch(currentOrgStore, emitOrg);
const block = {
  detail: "detail",
  setting: "setting",
};

const initFormValue = () => {
  orgDataDetailInput.value = [
    //re format -TODO
    {
      valueField: "name",
      required: true,
      hindText: getComponentUiText(
        "app-settings-organisation-detail-display-name-note-1",
      ),
      label: getComponentUiText(
        "app-settings-organisation-detail-display-name-1",
      ),
    },
    {
      valueField: "nameLegal",
      required: true,
      hindText: "",
      label: getComponentUiText(
        "app-settings-organisation-detail-legal-name-1",
      ),
    },
    {
      valueField: "nameCode",
      required: true,
      hindText: "",
      label: getComponentUiText("app-settings-organisation-detail-name-code-1"),
    },
    {
      valueField: "foundedDate",
      required: false,
      hindText: "",
      label: getComponentUiText(
        "app-settings-organisation-detail-founded-date-1",
      ),
      type: "date",
    },
    // {
    //   valueField: "registerNumber",
    //   required: false,
    //   hindText: "",
    //   label: getComponentUiText(
    //     "app-settings-organisation-detail-register-number-1",
    //   ),
    // },
    // {
    //   valueField: "location",
    //   required: true,
    //   hindText: getComponentUiText(
    //     "app-settings-organisation-detail-location-note-1",
    //   ),
    //   label: getComponentUiText("app-settings-organisation-detail-location-1"),
    // },
    // {
    //   valueField: "timezone",
    //   required: false,
    //   hindText: "",
    //   label: getComponentUiText("app-settings-organisation-detail-timezone-1"),
    // },
    // {
    //   valueField: "language",
    //   required: false,
    //   hindText: "",
    //   label: getComponentUiText("app-settings-organisation-detail-language-1"),
    // },
  ];
  orgDataSettingInput.value = [
    {
      valueField: "requireMFA",
      required: false,
      label: `${getComponentUiText(
        "app-settings-organisation-detail-require-mfa-1",
      )}?`,
      hindText: getComponentUiText(
        "app-settings-organisation-detail-require-mfa-hint-1",
      ),
      type: "toggle",
    },
    {
      valueField: "secretDisabledPasswordReset",
      required: false,
      label: `${getComponentUiText(
        "app-settings-organisation-detail-disable-secret-password-rest-1",
      )}?`,
      hindText: getComponentUiText(
        "app-settings-organisation-detail-disable-secret-password-rest-hint-1",
      ),
      type: "toggle",
    },
    {
      valueField: "secretDisabledEmailVerify",
      required: false,
      label: `${getComponentUiText(
        "app-settings-organisation-detail-disable-secret-email-verify-1",
      )}?`,
      hindText: getComponentUiText(
        "app-settings-organisation-detail-disable-secret-email-verify-hint-1",
      ),
      type: "toggle",
    },
    {
      valueField: "secretDisabledUserInvite",
      required: false,
      label: `${getComponentUiText(
        "app-settings-organisation-detail-disable-user-invite-1",
      )}?`,
      hindText: getComponentUiText(
        "app-settings-organisation-detail-disable-user-invite-hint-1",
      ),
      type: "toggle",
    },
    {
      valueField: "secretDisabledChecklistRequested",
      required: false,
      label: `${getComponentUiText(
        "app-settings-organisation-detail-disable-checklist-requested-1",
      )}?`,
      hindText: getComponentUiText(
        "app-settings-organisation-detail-disable-checklist-requested-hint-1",
      ),
      type: "toggle",
    },
  ];
  const orgValue = cloneDeep(currentOrg.value) as IEditOrgDetail;
  orgDataDetailInput.value.forEach((item) => {
    form[item.valueField] = orgValue[item.valueField];
  });
  orgDataSettingInput.value.forEach((item) => {
    form[item.valueField] = orgValue[item.valueField];
  });

  oldValueOrg.value = cloneDeep(form);
  if (isLoading.value) {
    EventEmitter.emit(EmitterEvents.PAGE_LOADING_COMPLETED);
  }
};
const isCallApi = ref(false);

const onSubmit = async () => {
  isCallApi.value = true;
  try {
    const result = await v$.value.$validate();
    if (result) {
      const payload: IOrgUpdateInput = {
        nameDisplay: form.name,
        nameCode: form.nameCode,
        nameLegal: form.nameLegal,
        requireMFA: form.requireMFA,
        foundedDate: form.foundedDate,
        secretDisabledPasswordReset: form.secretDisabledPasswordReset,
        secretDisabledEmailVerify: form.secretDisabledEmailVerify,
        secretDisabledUserInvite: form.secretDisabledUserInvite,
        secretDisabledChecklistRequested: form.secretDisabledChecklistRequested,
      };
      // remove foundedDate if empty
      if (!payload.foundedDate) {
        delete payload.foundedDate;
      }
      const response = await putOrgProfile(payload);
      if (response.data) {
        oldValueOrg.value = cloneDeep(form);
        store.dispatch("Org/setCurrentOrg", response.data.data);
        store.dispatch("Org/fetchOrgList");
        EventEmitter.emit(EmitterEvents.RELOAD_CURRENT_USER_MEMBERSHIPS);
      }
      const message = getComponentUiText(
        "app-settings-org-update-success-message-1",
      );
      const emitData: IToastMessage = {
        variant: ToastVariant.SUCCESS,
        message,
      };
      EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
    }
  } catch (error: any) {
    form.requireMFA = oldValueOrg.value.requireMFA;
    form.secretDisabledPasswordReset =
      oldValueOrg.value.secretDisabledPasswordReset;
    form.secretDisabledEmailVerify =
      oldValueOrg.value.secretDisabledEmailVerify;
    form.secretDisabledUserInvite = oldValueOrg.value.secretDisabledUserInvite;
    form.secretDisabledChecklistRequested =
      oldValueOrg.value.secretDisabledChecklistRequested;
    if (error && error.data) {
      showErrorAPI(error, Org.putOrgProfile);
    }
  } finally {
    isCallApi.value = false;
  }
};

const detailActions: Action[] = [
  {
    icon: AddIcon,
    title: "app-settings-organisation-details-action-manage-domains-1",
    titleClass: "tw-max-w-[149px]",
    onClick: () => handleClickActionButton(routers.settingDomains),
  },
  {
    icon: UserIcon,
    title: "app-settings-organisation-details-action-manage-team-1",
    titleClass: "tw-w-[149px]",
    onClick: () => handleClickActionButton(routers.settingTeamMembers),
  },
];

const handleClickActionButton = (routerUrl: any) => {
  router.push(routerUrl);
};

return (_ctx: any,_cache: any) => {
  const _component_brandpattern = _resolveComponent("brandpattern")!
  const _component_BForm = _resolveComponent("BForm")!

  return (_openBlock(), _createBlock(AppBarLayout, null, {
    default: _withCtx(({ activeHierarchy }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_brandpattern, {
          ref: "animation",
          page: "APPBARLAYOUT"
        }, null, 512),
        _createVNode(backgroundComponent),
        _createVNode(ActivePathWrapper, {
          "active-hierarchy": activeHierarchy,
          "is-button-enable": isEnableButton.value,
          "button-title": _unref(getComponentUiText)('app-common-save-change-button-1'),
          "is-call-api": isCallApi.value,
          onClickButton: onSubmit
        }, null, 8, ["active-hierarchy", "is-button-enable", "button-title", "is-call-api"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(GlobalAvatar, {
            name: currentOrgName.value,
            src: urlAvatar.value,
            "class-name": 'org-detail-org-icon'
          }, null, 8, ["name", "src"]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(currentOrgName.value), 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(currentOrg).nameLegal), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(getComponentUiText)(
                      "app-settings-organisation-detail-title-1",
                    )), 1)
                ]),
                _createVNode(_component_BForm, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(orgDataDetailInput), (inputItem, inputIndex) => {
                      return (_openBlock(), _createElementBlock("div", { key: inputIndex }, [
                        (inputIndex === 6)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", {
                          class: _normalizeClass(`${inputIndex === 0 ? 'tw-mt-10 ' : 'tw-mt-5'}`)
                        }, [
                          _createElementVNode("div", _hoisted_13, [
                            (inputItem.valueField === 'foundedDate')
                              ? (_openBlock(), _createBlock(DatePicker, {
                                  key: 0,
                                  "data-cy-id": "org-detail-founded-date",
                                  "model-value": form[`${inputItem.valueField}`],
                                  type: _unref(INPUT_TYPE).Date,
                                  title: inputItem.label,
                                  required: false,
                                  validation: _unref(v$)[`${inputItem.valueField}`],
                                  class: "tw-placeholder-[#b7b7b7]",
                                  placeholder: inputItem.label,
                                  "is-auto-focus": false,
                                  "input-class": `bg-white`,
                                  "onUpdate:modelValue": 
                            (value) => (form[`${inputItem.valueField}`] = value)
                          
                                }, null, 8, ["model-value", "type", "title", "validation", "placeholder", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true),
                            (inputItem.valueField !== 'foundedDate')
                              ? (_openBlock(), _createBlock(BaseInput, {
                                  key: 1,
                                  id: inputItem.valueField,
                                  modelValue: form[`${inputItem.valueField}`],
                                  "onUpdate:modelValue": ($event: any) => ((form[`${inputItem.valueField}`]) = $event),
                                  validation: _unref(v$)[`${inputItem.valueField}`],
                                  "validate-on-blur": true,
                                  class: "tw-placeholder-[#b7b7b7]",
                                  "data-cy-id": `org-detail-${inputItem.valueField}`,
                                  type: 'text',
                                  placeholder: inputItem.label,
                                  label: inputItem.label,
                                  "label-tooltip": inputItem.hindText,
                                  "label-tooltip-class": `tw-w-full`,
                                  "is-refresh": true
                                }, {
                                  default: _withCtx(() => [
                                    (inputItem.type === 'toggle')
                                      ? (_openBlock(), _createBlock(ToggleSwitch, {
                                          key: 0,
                                          "data-cy": "org-detail-mfa-toggle",
                                          "is-checked": form[`${inputItem.valueField}`],
                                          color: "#2573E9",
                                          "onUpdate:isChecked": ($event: any) => (
                              form[`${inputItem.valueField}`] = $event
                            )
                                        }, null, 8, ["is-checked", "onUpdate:isChecked"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["id", "modelValue", "onUpdate:modelValue", "validation", "data-cy-id", "placeholder", "label", "label-tooltip"]))
                              : _createCommentVNode("", true)
                          ])
                        ], 2)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(getComponentUiText)(
                      "app-settings-organisation-specific-setting-title-1",
                    )), 1)
                ]),
                _createVNode(_component_BForm, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(orgDataSettingInput), (inputItem, inputIndex) => {
                      return (_openBlock(), _createElementBlock("div", { key: inputIndex }, [
                        (inputIndex === 6)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", {
                          class: _normalizeClass(`${inputIndex === 0 ? 'tw-mt-10 ' : 'tw-mt-5'}`)
                        }, [
                          _createElementVNode("div", _hoisted_18, [
                            (inputItem.valueField === 'foundedDate')
                              ? (_openBlock(), _createBlock(DatePicker, {
                                  key: 0,
                                  "data-cy-id": "org-detail-founded-date",
                                  "model-value": form[`${inputItem.valueField}`],
                                  type: _unref(INPUT_TYPE).Date,
                                  title: inputItem.label,
                                  required: false,
                                  validation: _unref(v$)[`${inputItem.valueField}`],
                                  class: "tw-placeholder-[#b7b7b7]",
                                  placeholder: inputItem.label,
                                  "is-auto-focus": false,
                                  "input-class": `bg-white`,
                                  "onUpdate:modelValue": 
                            (value) => (form[`${inputItem.valueField}`] = value)
                          
                                }, null, 8, ["model-value", "type", "title", "validation", "placeholder", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true),
                            (inputItem.valueField !== 'foundedDate')
                              ? (_openBlock(), _createBlock(BaseInput, {
                                  key: 1,
                                  id: inputItem.valueField,
                                  modelValue: form[`${inputItem.valueField}`],
                                  "onUpdate:modelValue": ($event: any) => ((form[`${inputItem.valueField}`]) = $event),
                                  validation: _unref(v$)[`${inputItem.valueField}`],
                                  "validate-on-blur": true,
                                  class: "tw-placeholder-[#b7b7b7]",
                                  "data-cy-id": `org-detail-${inputItem.valueField}`,
                                  type: 'text',
                                  placeholder: inputItem.label,
                                  label: inputItem.label,
                                  "label-tooltip": inputItem.hindText,
                                  "label-tooltip-class": `tw-w-full`,
                                  "is-refresh": true,
                                  "col-input-class": `tw-flex col-input-mfa`
                                }, {
                                  default: _withCtx(() => [
                                    (inputItem.type === 'toggle')
                                      ? (_openBlock(), _createBlock(ToggleSwitch, {
                                          key: 0,
                                          "data-cy": "org-detail-mfa-toggle",
                                          "is-checked": form[`${inputItem.valueField}`],
                                          color: "#2573E9",
                                          "onUpdate:isChecked": ($event: any) => (
                              form[`${inputItem.valueField}`] = $event
                            )
                                        }, null, 8, ["is-checked", "onUpdate:isChecked"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["id", "modelValue", "onUpdate:modelValue", "validation", "data-cy-id", "placeholder", "label", "label-tooltip"]))
                              : _createCommentVNode("", true)
                          ])
                        ], 2)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(ActionButton, {
                "profile-actions": detailActions,
                class: "tw-max-w-[241px]"
              })
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})